<template>
  <div>BiCruzfarmaRed</div>
</template>

<script>
export default {
  name: 'BiCruzfarmaRed',
};
</script>
